import { motion } from 'framer-motion';
import { FaAward, FaUsers, FaServer, FaHeadset, FaExchangeAlt } from 'react-icons/fa';

const stats = [
  { number: "15+", label: "Years Experience", icon: FaAward },
  { number: "150+", label: "Clients", icon: FaUsers },
  { number: "50+", label: "Software Implementations", icon: FaServer },
  { number: "24/7", label: "Technical Support", icon: FaHeadset },
  { number: "Millions", label: "Transactions Processed", icon: FaExchangeAlt },
];

export default function Stats() {
  return (
    <section className="py-8 md:py-10 bg-white border-y border-gray-200">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6 text-center">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={index}
                className="p-3 md:p-4 group cursor-pointer hover:bg-gray-50 rounded-xl transition-all"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Icon className="text-2xl md:text-3xl text-micropoint-gold mx-auto mb-1.5 md:mb-2 group-hover:scale-110 group-hover:rotate-6 transition-all" />
                <div className="text-xl md:text-3xl font-bold text-gray-900 group-hover:text-micropoint-gold transition-colors">
                  {stat.number}
                </div>
                <div className="text-xs md:text-sm text-gray-600 group-hover:text-gray-900 transition-colors">
                  {stat.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}